import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getAuth, Auth, signInAnonymously, User, onAuthStateChanged } from 'firebase/auth';
import { observable } from '@legendapp/state';

const firebaseConfig = {
  apiKey: "AIzaSyA6FlHPG-C-MC76_qdDOhIhfmzBa_uDZ0U",
  authDomain: "virtualhalfai-b777a.firebaseapp.com",
  projectId: "virtualhalfai-b777a",
  storageBucket: "virtualhalfai-b777a.firebasestorage.app",
  messagingSenderId: "404902259408",
  appId: "1:404902259408:web:f59e2bef61d2c49bcf8cd5"
};

let app: FirebaseApp | null = null;
let auth: Auth | null = null;

try {
  if (!getApps().length) {
    console.log('Firebase: Initializing app');
    app = initializeApp(firebaseConfig);
    console.log('Firebase: App initialized');
    auth = getAuth(app);
    console.log('Firebase: Auth initialized');
  } else {
    app = getApps()[0];
    auth = getAuth(app);
  }
} catch (error) {
  console.error('Firebase initialization error:', error);
}

export { app, auth };

interface UserData {
  uid: string;
  isAnonymous: boolean;
}

export const currentUser$ = observable<UserData | null>(null);

let authListenerInitialized = false;

export function initializeAuthListener() {
  console.log('Firebase: initializeAuthListener called', { authListenerInitialized, auth });
  if (!authListenerInitialized && auth) {
    authListenerInitialized = true;
    console.log('Firebase: Setting up onAuthStateChanged');
    onAuthStateChanged(auth, (user) => {
      console.log('Firebase: Auth state changed', user);
      if (user) {
        currentUser$.set({
          uid: user.uid,
          isAnonymous: user.isAnonymous,
        });
      } else {
        currentUser$.set(null);
      }
    }, (error) => {
      console.error('Firebase: Auth state change error:', error);
    });
  } else {
    console.log('Firebase: Skipping auth listener setup', { authListenerInitialized, auth });
  }
}

export async function signInAnonymouslyUser(): Promise<User> {
  try {
    const userCredential = await signInAnonymously(auth);
    return userCredential.user;
  } catch (error) {
    console.error('Error signing in anonymously:', error);
    throw error;
  }
}

export function getCurrentUser(): User | null {
  return auth.currentUser;
}

export function onAuthStateChange(callback: (user: User | null) => void): () => void {
  return onAuthStateChanged(auth, callback);
}

export function signOutUser(): Promise<void> {
  return auth.signOut();
}
